// Single source of truth for priority colours.
// color  = left-border strip + dot + badge border
// bg     = card / badge background
// text   = badge text
export const PRIORITY_COLORS = {
  High:     { color: '#b91c1c', bg: 'rgba(185,28,28,0.10)',   text: '#7a1e0e' },
  Medium:   { color: '#f59e0b', bg: 'rgba(251,196,144,0.25)', text: '#92400e' },
  Low:      { color: '#16a34a', bg: 'rgba(22,163,74,0.12)',   text: '#166534' },
};

export const PRIORITY_RANK = { High: 1, Medium: 2, Low: 3 };   // decision 64: Critical merged into High

export function getPriorityColors(priority) {
  return PRIORITY_COLORS[priority] || PRIORITY_COLORS.Medium;
}
